<template>
    <rkm-area title="Medicamento(s) de uso contínuo">
        <template slot="trailing">
            <rkm-button
                @click="$refs.Modal.open()"
                color="primary"
                id="medicamentos"
                title="Adicionar medicamento"
                small
            >
                <rkm-icon icon="plus" />
            </rkm-button>
        </template>

        <List :data="data" :hide-info="hideInfo" />
        <Modal :data="data" ref="Modal" />
    </rkm-area>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

export default {
    components: { List, Modal },
    props: {
        data: { type: Object, required: true },
        hideInfo: { type: Boolean, default: false },
    }
}
</script>